const Input = ({ 
    id, 
    error, 
    onChange, 
    onBlur,
    autocomplete = '', 
    className = '', 
    label = '', 
    value = '', 
    type = 'text', 
    hideLabel = false, 
    disabled = false, 
    required = false, 
    placeholder = '', 
    props = {} 
}) => {

    const renderLabel = () => {
        if (hideLabel || label === '') return null;
        return (
            <label htmlFor={id}>
                {label}
                {required && <span className="required-indicator">*</span>}
            </label>
        );
    };

    return (
        <div className={`form-group ${error ? 'has-error' : ''}`}>
            {renderLabel()}
            <input 
                type={type} 
                id={id} 
                name={id} 
                onChange={onChange} 
                onBlur={onBlur} 
                value={value} 
                className={error ? className + ' error' : className} 
                autoComplete={autocomplete} 
                disabled={disabled} 
                required={required} 
                placeholder={placeholder} 
                {...props} 
            />
            {error && (
                <p className="error-msg">
                    <i className="icon-attention"></i> {error.message}
                </p>
            )}
        </div>
    );
}
export default Input;
